import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeadphonesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"headphones"}/>
}
